import React, { useState, useEffect } from 'react';
import { useTheme, makeStyles } from '@material-ui/core/styles'
import { Box, CircularProgress, List, ListItem, Typography, Button, TextField, DialogContent, Dialog } from '@material-ui/core'
import { useTranslate, useDataProvider, Loading, usePermissions } from 'react-admin';
import { useHistory, useLocation } from 'react-router-dom';
import ConfirmDialog from '../CustomizedUIs/confirmDialog';
import { Add, Clear, Close, Create, DeleteOutline } from '@material-ui/icons'
import CreateServices from './create'
import Snackbar from '../common/snackbar';
import icArrowUp from '../assets/icons/white-arrow-up.png';
import icArrowDown from '../assets/icons/white-arrow-down.png';
import Checkbox from '../checkbox'
import Search from '../search'
import { StyledButton } from '../common/table/index'
import DeleteButton from '../CustomizedUIs/DeleteButton';
import EditService from './edit'
const useStyles = makeStyles(theme => ({
    tableSortLabel: {
        color: 'theme.palette.common.white',
        '&:hover': {
            color: 'white'
        },
        '&:focus': {
            color: 'white'
        },
    },
    textEdit: {
        fontFamily: 'UniviaPro',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
    dialogContent: {
        padding: '20px 8px !important'
    },
    icons: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 7,
        cursor: 'pointer'
    },
    icon: {
        width: 9,
        height: 9
    },
    subText: {
        fontFamily: 'UniviaPro-Medium',
        fontWeight: '500',
        lineHeight: "13.2px",
        marginLeft: 10,
        letterSpacing: 'normal',
        color: '#88898c',
        fontSize: 11
    }
}));

const fakeData = [{
    name: 'Anders Andersson',
    role: 'User',
    mail: 'anders.andersson@andersson.com',
    status: 'Active',
    statusCode: 1
},
{
    name: 'Anders Andersson',
    role: 'Superuser',
    mail: 'anders.andersson@andersson.com',
    status: 'Active',
    statusCode: 1
},
{
    name: 'Anders Andersson',
    role: 'Superuser',
    mail: 'anders.andersson@andersson.com',
    status: 'Awaiting connection',
    statusCode: 2
},
{
    name: 'Anders Andersson',
    role: 'Superuser',
    mail: 'anders.andersson@andersson.com',
    status: 'Awaiting Reply',
    statusCode: 3
},
{
    name: 'Anders Andersson',
    role: 'Superuser',
    mail: 'anders.andersson@andersson.com',
    status: 'last activity: 23-JAN-2021  Time:10.43PM',
    statusCode: 4
},
]

const Services = (props) => {
    const dataProvider = useDataProvider()
    const classes = useStyles()
    const translate = useTranslate()
    const history = useHistory()
    const [data, setData] = useState([])
    const [click, SetClick] = useState({ name: false, category: false, link: false })
    const { permissions, loaded } = usePermissions();
    const [openConfirmDialog, setOpenConfirmDialog] = useState({
        status: false,
        index: -1
    })
    const [loading, setLoading] = useState(false)
    const [showSnackbar, setShowSnackbar] = useState({ status: false })
    const [showMessagePopup, setMessagePopup] = useState(false)
    const [showSnackbarEdit, setShowSnackbarEdit] = useState({
        name: '',
        message: '',
        status: false
    })
    const [filter, setFilter] = useState('')
    const [dataFilter, setDataFilter] = useState([])
    const [creating, setCreating] = useState(false)
    const [editing, setEditing] = useState({
        status: false
    })

    const location = useLocation();
    const theme = useTheme()

    const getList = () => {
        setLoading(true)
        setFilter("")
        dataProvider('GET_LIST', "Services", {
            filter: {

            },
            pagination: {
                page: 1,
                perPage: -1
            },
            sort: { field: 'createdAt', order: 'ASC' },

        })
            .then(({ data }) => {
                if (data) {
                    setData(data);
                }
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            })
    }
    const onSort = (name, value) => {
        let temps = [...data]
        temps.sort((v1, v2) => {
            let a = name === 'category' ? a.category.name : v1[name]
            let b = name === 'category' ? a.category.name : v2[name]
            if (a < b)
                return value === 'UP' ? -1 : 1
            if (a > b)
                return value === 'UP' ? 1 : -1
            return 0
        })
    }

    useEffect(() => {
        if (location.state && location.state.status) {
            setShowSnackbar(location.state);
            setTimeout(() => {
                setShowSnackbar({ status: false });
            }, 6000);
        }
        getList()
    }, [])

    const onCancel = (index) => {
        let temps = data.slice()
        temps[index].edit = false
        delete temps[index].editName
        setData(temps)
    }

    const onClick = (prop) => {
        let temps = [...data]
        temps.sort((a, b) => {
            var x, y
            if (prop === 'category') {
                x = a[prop].name.toLowerCase();
                y = b[prop].name.toLowerCase();
            } else {
                x = a[prop].toLowerCase();
                y = b[prop].toLowerCase();
            }

            if (x < y) { return click[prop] ? -1 : 1; }
            if (x > y) { return click[prop] ? 1 : -1; }
            return 0
        })
        setData(temps)
        SetClick({ ...click, [prop]: !click[prop] })
    }

    const handleOnDelete = () => {

        dataProvider('DELETE', "Services", {
            id: data[openConfirmDialog.index].id
        })
            .then(({ data }) => {
                getList()
                setShowSnackbar({
                    status: true,
                    name: data[0].name,
                    message: translate(`pos.relatives.deleteRelative.success`)

                })
                setTimeout(() => setShowSnackbar({ status: false }), 6000)
                setOpenConfirmDialog({ status: false, index: -1 })
            })
            .catch(error => {
                setOpenConfirmDialog({ status: false, index: -1 })
            })
    }







    const onClear = () => {
        let temps = dataFilter.slice()
        temps.map(item => {
            delete item.checked
            return item
        })
        setDataFilter(temps)
    }


    const submitFilter = () => {
        setDataFilter(data.filter(item => item.firmware.name.toUpperCase().includes(filter.toUpperCase())
            || item.model.name.toString().toUpperCase().includes(filter.toUpperCase())
            || item.version.toString().toUpperCase().includes(filter.toUpperCase())
        ))
    }


    // if (creating) return <CreateServices setCreating={setCreating} cluster={props.cluster} setShowSnackbar={setShowSnackbar} />
    // if (editing.status) return <EditService setEditing={setEditing} data={editing.data} cluster={props.cluster} setShowSnackbar={setShowSnackbar} />
    if (loading || !loaded) return <Loading />

    return (
        <Box width='100%' display='flex' justifyContent='center'>
            <Box width={props.inCluster ? '100%' : '80%'}>
                <Box width='100%' display='flex' justifyContent='flex-end' mt={10}>

                    <Snackbar
                        show={showSnackbar.status}
                        boldText={showSnackbar.name || ""}
                        message={showSnackbar.message || ""}
                        onClose={() => setShowSnackbar({ status: false })}
                    />

                </Box>
                <Box width='100%' display='flex' alignItems='center'>
                    <Box flexGrow={1} display="flex" flexDirection="row" alignItems="center" >
                        <Typography variant='h5' style={{ fontFamily: 'UniviaPro-Medium', lineHeight: '21.6px', color: '#4f5064', fontWeight: 500 }}>{'External services'}</Typography>
                    </Box>
                    <Search
                        disableButton={true}
                        placeholder={'Search external service'}
                        onChangeText={setFilter}
                        getList={submitFilter}
                    />
                    {
                        // permissions.functionAction.find(value => value.function === 'Remote FirmWare' && value.isUpdate) &&
                        <Box ml={4}>
                            <Button variant='contained' color='primary' onClick={() => history.push(`/ExternalService/create`)}>
                                <Typography style={{ fontSize: '9px', lineHeight: '11px', letterSpacing: '0.36px', fontFamily: 'UniviaPro-Bold' }}>{'Create new service'}</Typography>

                                <Add />
                            </Button>

                        </Box>
                    }

                </Box>
                <Box>
                    <Box display='flex' px={3} py={2} mb={2} mt={1} bgcolor={theme.palette.primary.main}>
                        <Box flexGrow={1} display='flex' alignItems='center'>
                            {
                                dataFilter.filter(item => item.checked).length > 0 ?
                                    <Box display='flex' justifyContent='space-between' width='100%' style={{ pointerEvents: permissions.functionAction.find(value => value.function === 'Remote FirmWare' && value.isUpdate) ? 'auto' : 'none' }}>
                                        <StyledButton
                                            onClick={() => {
                                                setOpenConfirmDialog({
                                                    status: true,
                                                    index: -1
                                                })
                                            }}
                                            variant='text'
                                            startIcon={<DeleteOutline />}
                                        >
                                            {translate(`pos.common.delete`)}
                                        </StyledButton>
                                        <StyledButton
                                            onClick={onClear}
                                            variant='text'
                                            startIcon={<Clear />}
                                        >{dataFilter.filter(item => item.checked).length} {dataFilter.filter(item => item.checked).length > 1 ? translate('pos.categories.filesSelected') : translate('pos.categories.fileSelected')}</StyledButton>
                                    </Box>
                                    :
                                    <Box width='100%' display='flex'>
                                        <Box display='flex' width={100}>
                                            <Typography
                                                style={{ cursor: 'pointer', color: 'white', fontSize: '13px', lineHeight: '16.3px', letterSpacing: '0.13px', fontFamily: 'UniviaPro' }}
                                                variant='body1'>
                                                Logo
                                            </Typography>
                                        </Box>
                                        <Box display='flex' width={200}>
                                            <Typography
                                                style={{ cursor: 'pointer', color: 'white', fontSize: '13px', lineHeight: '16.3px', letterSpacing: '0.13px', fontFamily: 'UniviaPro' }}
                                                variant='body1'>
                                                Category
                                            </Typography>
                                            <div className={classes.icons}>
                                                <img alt='Up arrow' src={icArrowUp} className={classes.icon} onClick={() => onClick('category')} style={{ opacity: click.category === true ? 0 : 1 }} />
                                                <img alt='Down arrow' src={icArrowDown} className={classes.icon} style={{ opacity: click.category === false ? 0 : 1 }} onClick={() => onClick('category')} />
                                            </div>
                                        </Box>
                                        <Box display='flex' width={250}>
                                            <Typography
                                                style={{ cursor: 'pointer', color: 'white', fontSize: '13px', lineHeight: '16.3px', letterSpacing: '0.13px', fontFamily: 'UniviaPro' }}
                                                variant='body1'>
                                                Name
                                            </Typography>
                                            <div className={classes.icons}>
                                                <img alt='Up arrow' src={icArrowUp} className={classes.icon} onClick={() => onClick('name')} style={{ opacity: click.name === true ? 0 : 1 }} />
                                                <img alt='Down arrow' src={icArrowDown} className={classes.icon} style={{ opacity: click.name === false ? 0 : 1 }} onClick={() => onClick('name')} />
                                            </div>
                                        </Box>
                                        <Box display='flex' width={300}>
                                            <Typography
                                                style={{ cursor: 'pointer', color: 'white', fontSize: '13px', lineHeight: '16.3px', letterSpacing: '0.13px', fontFamily: 'UniviaPro' }}
                                                variant='body1'>
                                                Link
                                            </Typography>
                                            <div className={classes.icons}>
                                                <img alt='Up arrow' src={icArrowUp} className={classes.icon} onClick={() => onClick('link')} style={{ opacity: click.link === true ? 0 : 1 }} />
                                                <img alt='Down arrow' src={icArrowDown} className={classes.icon} style={{ opacity: click.link === false ? 0 : 1 }} onClick={() => onClick('link')} />
                                            </div>
                                        </Box>

                                    </Box>
                            }

                        </Box>
                    </Box>
                    <Box height='400px' style={{ overflow: 'auto' }}>
                        {
                            data
                                .filter((item) =>
                                    item?.name?.toLowerCase()?.includes(filter.toLowerCase())
                                    || item?.link?.toLowerCase()?.includes(filter.toLowerCase())
                                    || item?.category?.name?.toLowerCase()?.includes(filter.toLowerCase())
                                )
                                .map((item, index) => (
                                    item && <Box key={'channel' + index} display='flex' px={3} py={2} mt={1} bgcolor='white'>
                                        <Box flexGrow={1} display='flex' alignItems='center'>
                                            <Box flexGrow={1} display='flex' alignItems='center'>

                                                <Box display='flex' width={100} whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis' >
                                                    <Box width={60} height={40}>
                                                        <img src={process.env.REACT_APP_BASE_API_URL + '/media/' + (item?.logo?.fd || '')} style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'contain'
                                                        }} />
                                                    </Box>
                                                    {/* <Typography
                                                        style={{ textDecorationLine: 'none', letterSpacing: 'normal', fontFamily: 'UniviaPro-Book' }}
                                                        variant='body1'>
                                                        {item.logo.fd}
                                                    </Typography> */}
                                                </Box>

                                                <Box display='flex' width={200} whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis'>
                                                    <Typography
                                                        style={{ cursor: 'pointer', textDecorationLine: 'none', letterSpacing: 'normal', fontFamily: 'UniviaPro-Book' }}
                                                        variant='body1' color='primary'>
                                                        {item.category?.name}
                                                    </Typography>
                                                </Box>

                                                <Box display='flex' width={250} whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis'>
                                                    <Typography
                                                        style={{ cursor: 'pointer', textDecorationLine: 'none', letterSpacing: 'normal', fontFamily: 'UniviaPro-Book' }}
                                                        variant='body1' color='primary'>
                                                        {item.name}
                                                    </Typography>
                                                </Box>
                                                <Box display='flex' width={300} whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis'>
                                                    <Typography
                                                        style={{ cursor: 'pointer', textDecorationLine: 'none', letterSpacing: 'normal', fontFamily: 'UniviaPro-Book' }}
                                                        variant='body1' color='primary'>
                                                        {item.link}
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            <Box display='flex' justifyContent='flex-end' alignItems='center' width='auto'>
                                                {
                                                    props.inCluster && (
                                                        <Button
                                                            style={{ marginRight: 8 }}
                                                            variant="contained"
                                                            color='primary'
                                                            size='small'
                                                            onClick={() => props.setOpenDetail({
                                                                status: true,
                                                                data: item
                                                            })}
                                                        >
                                                            <Typography className={classes.textEdit} style={{ padding: '8px' }}>USE IN </Typography>
                                                        </Button>
                                                    )
                                                }

                                                <Button
                                                    style={{ marginRight: 8 }}
                                                    variant="contained"
                                                    color='primary'
                                                    size='small'
                                                    onClick={() => history.push('/ExternalService/' + item.id)}
                                                >
                                                    <Typography className={classes.textEdit} style={{ padding: '8px' }}>{translate(`pos.user.edituser`)} </Typography>
                                                </Button>
                                                <DeleteButton bgColor={theme.palette.grey.A700} border='none' onClick={() => setOpenConfirmDialog({ status: true, index: index })} />
                                            </Box>

                                        </Box>


                                    </Box>
                                ))
                        }
                    </Box>
                </Box>
            </Box>
            <ConfirmDialog
                open={openConfirmDialog.status}
                handleClose={() => { setOpenConfirmDialog({ status: false, index: -1 }) }}
                handleConfirm={handleOnDelete}
                ContentText={translate('pos.user.contentDelete')}
                Tittle={translate('pos.deviceFirmware.delete')} />
            {/* 
            <Dialog open={showMessagePopup} scroll='paper'>
                <Box display='flex' justifyContent='flex-end' alignContent='center' mr={2} mt={2}>
                    <IconRadiusButton onClick={onCloseMessagePopup}>
                        <Close color='primary' />
                    </IconRadiusButton>
                </Box>
                <DialogContent>
                    <Box mx={2.5} className={classes.dialogContent}>
                        {messagePopupContent}
                    </Box>
                </DialogContent>
            </Dialog> */}
        </Box>
    )
}
export default Services